module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor_/coolant_tank_cap_128_bake.png";